import { apiUc as http } from '../http';
class ServiceCRUD {
  constructor(path) {
    this.path = path;
  }

  getAllTeamsByUser(login) {
    const targetPath = `${this.path}/user/${login}`;

    return http.get(targetPath);
  }

  getAll(page, size, showDisable = false, querySearch = '', queryParams = {}) {
    if (!page || !size)
      return http.get(`${this.path}`, {
        params:
          Object.keys(queryParams).length > 0
            ? { ...queryParams, showDisable }
            : { showDisable }
      });

    return http.get(`${this.path}`, {
      headers: {
        limit: size,
        offset: size * (page - 1)
      },
      params: {
        showDisable: showDisable,
        q: querySearch,
        ...queryParams
      }
    });
  }

  getAllFilterTeam(
    showAllQueues = false,
    page,
    size,
    showDisabled = false,
    querySearch = '',
    queryParams = {}
  ) {
    const login = localStorage.getItem('login');

    const params = {
      login,
      showAllQueues,
      showDisable: showDisabled,
      q: querySearch,
      ...queryParams
    };

    if (!page || !size) {
      return http.get(`${this.path}`, {
        params
      });
    }

    return http.get(`${this.path}`, {
      headers: {
        limit: size,
        offset: size * (page - 1)
      },
      params
    });
  }

  getAllSimple() {
    return http.get(`${this.path}/all`);
  }

  getAllShowDisable(showDisable) {
    return http.get(`${this.path}?showDisable=${showDisable}`);
  }

  getAllAgentsforSupervisor(login) {
    return http.get(`${this.path}/supervisor/${login}`);
  }

  getAllSeach(page, size, query, showDisable, login) {
    return http.get(
      `${this.path}?q=${query}&showDisable=${showDisable}&login=${login}`,
      {
        headers: {
          limit: size,
          offset: size * (page - 1)
        }
      }
    );
  }
  getAllShowSupervisor(page, size, query, showDisable, isSupervisor) {
    return http.get(
      `${this.path}?&q=${query}&showDisable=${showDisable}&isSupervisor=${isSupervisor}`,
      {
        headers: {
          limit: size,
          offset: size * (page - 1)
        }
      }
    );
  }

  get(id) {
    return http.get(`${this.path}/${id}`);
  }
  post(data) {
    return http.post(`${this.path}`, data);
  }
  put(id, data) {
    return http.put(`${this.path}/${id}`, data);
  }

  create(data) {
    return http.post(this.path, data);
  }

  update(id, data) {
    return http.put(`${this.path}/${id}`, data);
  }

  delete(id) {
    return http.delete(`${this.path}/${id}`);
  }

  recovery(id) {
    return http.put(`${this.path}/${id}/enable`);
  }

  enableExtension(entension_number) {
    return http.put(`${this.path}/${entension_number}/enable`);
  }

  getConfig() {
    return http.get(`${this.path}`);
  }

  updateConfig(data) {
    return http.put(`${this.path}`, data);
  }
}

export default ServiceCRUD;
